module.exports = __webpack_public_path__ + "media/46552c7083894fbfa1942773a9ddb305.0f008f4a.mp4";